import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { addReducer, trackPage } from '@atresmedia/datalayer';
import waitForLoad from '@atresmedia/a3utils/dist/utils/waitForLoad';
import cmpResponseSites from '@atresmedia/datalayer/lib/reducers/cmpReducerSites';
import tagsReducer from './tagsReducer';
import pageReducer from './pageReducer';
import adBlockReducer from './adBlockReducer';

class Analytics extends React.Component {
  static propTypes = {
    history: PropTypes.shape({ listen: PropTypes.func }).isRequired
  };

  firstTrack = true;

  componentDidMount() {
    this.addReducers();
    this.track();
    if (this.props.history) {
      this.unlisten = this.props.history.listen((event, action) => {
        const { state = {} } = event;

        if (action !== 'POP' && !state.isScrollExistingPage) {
          /* eslint-disable no-underscore-dangle */
          if (window._satellite) {
            window._satellite.track('consentReady');
          }
          this.track();
        }
      });
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  addReducers = () => {
    const noticiaVideo = document.querySelector(
      'atres-widget[data-type=video-player]'
    )
      ? 'si'
      : 'no';

    addReducer(() => ({ noticiaVideo }));
    addReducer(adBlockReducer);

    addReducer(pageReducer);
    addReducer(tagsReducer);
    addReducer(cmpResponseSites, cmpResponseSites.id);
  };

  firstTrackPage = (data, success) => {
    if (success) {
      this.firstTrack = false;
      trackPage();
      window.__tcfapi(
        'removeEventListener',
        2,
        this.firstTrackPage,
        data.listenerId
      );
    }
  };

  track = async () => {
    if (this.firstTrack) {
      // Esperamos que el cmp se cargue
      waitForLoad(window, '__tcfapi').then(() => {
        window.__tcfapi('addEventListener', 2, this.firstTrackPage);
      });
    } else {
      trackPage();
    }
  };

  render() {
    return null;
  }
}

export default withRouter(Analytics);
